import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenstackComponent } from './simple-icons-openstack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenstackComponent ],
    exports:      [ SimpleIconsOpenstackComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenstackModule {}
